import { render } from "./Kullanicilar.vue?vue&type=template&id=aa887e18"
import script from "./Kullanicilar.vue?vue&type=script&lang=js"
export * from "./Kullanicilar.vue?vue&type=script&lang=js"
script.render = render

export default script